/**
 * tdesign v0.43.3
 * (c) 2022 tdesign
 * @license MIT
 */

import { getAttach } from './dom.js';
import 'vue';
import 'raf';
import 'lodash/isString';
import './easing.js';

var TransferDom = {
  inserted: function inserted(el, binding) {
    if (!binding.value) return;
    var parentNode = getAttach(binding.value);
    parentNode === null || parentNode === void 0 ? void 0 : parentNode.appendChild(el);
  }
};

export { TransferDom as default };
//# sourceMappingURL=transfer-dom.js.map
